import { Actions, UIActionType } from './actions';
import { OpenedFrom } from '@/lib/gTagManager';
import MenuDrawer from '@/features/drawers/menu/MenuDrawer';
import HelpDrawer from '@/features/drawers/help/HelpDrawer';

export enum DrawerName {
  Help = 'HelpDrawer',
  Menu = 'MenuDrawer',
}

export const Drawer = {
  [DrawerName.Menu]: MenuDrawer,
  [DrawerName.Help]: HelpDrawer,
};

export interface DrawerModel {
  isOpen: boolean;
  drawerName: DrawerName | null;
}

const initialDrawerState: DrawerModel = {
  isOpen: false,
  drawerName: null,
};

export interface GamesSearchModel {
  isSearchDisplayed: boolean;
  searchValue: string | null;
}

const initialGamesSearchState: GamesSearchModel = {
  isSearchDisplayed: false,
  searchValue: null,
};

export interface UIState {
  isSingleGame: boolean;
  registrationOpenedFrom: OpenedFrom | null;
  loginOpenedFrom: OpenedFrom | null;
  photoIdScanModalSeen: boolean | null;
  drawer: DrawerModel;
  gamesSearch: GamesSearchModel;
}

const initialState = {
  isSingleGame: false,
  registrationOpenedFrom: null,
  loginOpenedFrom: null,
  photoIdScanModalSeen: null,
  drawer: initialDrawerState,
  gamesSearch: initialGamesSearchState,
};

export const uiReducers = (state = initialState, action: Actions): UIState => {
  switch (action.type) {
    case UIActionType.SetIsSingleGame:
      return {
        ...state,
        isSingleGame: action.isSingleGame,
      };
    case UIActionType.SetRegistrationOpenedFrom:
      return {
        ...state,
        registrationOpenedFrom: action.openedFrom,
      };
    case UIActionType.SetLoginOpenedFrom:
      return {
        ...state,
        loginOpenedFrom: action.openedFrom,
      };
    case UIActionType.SetPhotoIdScanModalSeen: {
      return {
        ...state,
        photoIdScanModalSeen: action.photoIdScanModalSeen,
      };
    }
    case UIActionType.OpenDrawer: {
      return {
        ...state,
        drawer: { isOpen: true, drawerName: action.drawerName },
      };
    }
    case UIActionType.CloseDrawer: {
      return {
        ...state,
        drawer: { isOpen: false, drawerName: null },
      };
    }
    case UIActionType.SetSearchDisplayed: {
      return {
        ...state,
        gamesSearch: {
          searchValue: state.gamesSearch.searchValue,
          isSearchDisplayed: action.displayed,
        },
      };
    }
    case UIActionType.SetSearchValue: {
      return {
        ...state,
        gamesSearch: {
          isSearchDisplayed: state.gamesSearch.isSearchDisplayed,
          searchValue: action.searchValue,
        },
      };
    }
    default:
      return state;
  }
};
